import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTheme } from "styled-components";
import { useDispatch } from "react-redux";

import {
  DashboardIcon,
  ArrowLeftIcon,
  MarketplaceIcon,
  // ChevronDownIcon,
  // PlusCircleIcon,
} from "assets/icons";
import { isChildRoute } from "utils";
import { useNavigation } from "utils/navigate";
import { Button } from "components/Button";
import LocationPath from "hooks/locationPath";
import { setCollapsedSidebar } from "Layout/slice";
// import {
//   setPortfolioViewMode,
//   setSelectedPortfolioIds,
// } from "features/Dashboard/slice";
import { AppMenuContainer } from "./Sidebar.styles";
import { closeIcon, hamburgerIcon } from "assets/icons";
import { Tooltip } from "components/Tooltip";
// import { SearchIcon2 } from "assets/icons";
import { DASHBOARD_PATH } from "features/Dashboard/routes";
import { CreateStrategiesIcon } from "assets/icons/index";
import { MARKETPLACE_V2_PATH } from "features/Explore/routes";
import { STRATEGY_V2_PATH } from "features/Strategy/routes";
import { MARKET_V2_PATH } from "features/Market/routes";
import { RESEARCH_PATH } from "features/Research/routes";
import { hasFreeOrCore } from "utils";
import { IconLock, SidebarResearchIcon } from "assets/icons";
import { useConnectedAccounts } from "features/Dashboard/hook/useConnectedAccounts";
import MultiStepModal from "shared/Modal/SnaptradeModal/MultiStepModal";
import { ChoosePlanModal } from "features/Account/v2/ChoosePlanModal";

export const AppMenu = ({ active = "" }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const collapsed = false;

  const [showBackButton, setShowBackButton] = useState(false);
  // const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [showSnaptradeModal, setShowSnaptradeModal] = useState(false);
  const [showPurchasePlanModal, setShowPurchasePlanModal] = useState(false);

  // const { portfolios, isLoading, refetch } = useConnectedAccounts();
  const { refetch } = useConnectedAccounts();

  // Get portfolio state from Redux
  // const portfolioViewMode = useSelector(
  //   (state) => state.portfolio.portfolioViewMode
  // );
  // const selectedPortfolioIds = useSelector(
  //   (state) => state.portfolio.selectedPortfolioIds
  // );

  const {
    navigateToV2,
    navigateToV2StrategyList,
    navigateToV2Marketplace,
    navigateBackToParent,
    navigateToV2Market,
    navigateToV2Research,
  } = useNavigation();

  const handleNavigateToStrategyList = () => {
    // setIsDashboardOpen(false);
    navigateToV2StrategyList();
  };

  const togglePurchasePlanModal = useCallback(() => {
    setShowPurchasePlanModal((prev) => !prev);
  }, []);

  // const toggleDashboardDropdown = () => {
  //   setIsDashboardOpen((prev) => !prev);
  //   // If not on dashboard, navigate to it
  //   if (!active.startsWith(DASHBOARD_PATH) && active !== "/") {
  //     navigateTo(`/dashboard?mode=combined`);
  //   }
  // };

  // const handleAccountSelect = (account) => {
  //   // Don't close dropdown to allow multiple selections in combined mode

  //   // If already on dashboard, update Redux state
  //   if (active.startsWith(DASHBOARD_PATH) || active === "/") {
  //     if (account?.id) {
  //       const accountIdStr = String(account.id);

  //       if (portfolioViewMode === "combined") {
  //         // In combined mode, toggle the portfolio (multi-select)
  //         if (selectedPortfolioIds.includes(accountIdStr)) {
  //           // Remove if already selected
  //           const newIds = selectedPortfolioIds.filter(
  //             (id) => id !== accountIdStr
  //           );
  //           dispatch(setSelectedPortfolioIds(newIds));
  //         } else {
  //           // Add to selection
  //           dispatch(
  //             setSelectedPortfolioIds([...selectedPortfolioIds, accountIdStr])
  //           );
  //         }
  //       } else {
  //         // In individual mode, replace selection
  //         dispatch(setSelectedPortfolioIds([accountIdStr]));
  //       }
  //     }
  //   } else {
  //     // Navigate to dashboard and set initial selection
  //     if (account?.id) {
  //       dispatch(setPortfolioViewMode("combined"));
  //       dispatch(setSelectedPortfolioIds([String(account.id)]));
  //       navigateTo(`/dashboard`);
  //     } else {
  //       navigateTo(`/dashboard`);
  //     }
  //   }
  // };

  const handlenavigateToV2Marketplace = () => {
    // setIsDashboardOpen(false);
    navigateToV2Marketplace();
  };

  const handleNavigateToParent = () => {
    navigateBackToParent();
  };

  const handleChangePath = useCallback((pathname) => {
    if (isChildRoute(pathname)) {
      /**
       * Dont show back button in sidebar: MVP2-1865
       * Not completely removing whole logic so if we need to revert this
       */
      // setShowBackButton(true);
    } else {
      setShowBackButton(false);
    }
  }, []);

  const toggleCollapsed = () => {
    dispatch(setCollapsedSidebar(false));
  };

  const handleNavigateToStockSearch = () => {
    // setIsDashboardOpen(false);
    navigateToV2Market();
  };

  const handleNavigateToResearch = () => {
    // setIsDashboardOpen(false);
    navigateToV2Research();
  };

  const toggleSnaptradeModal = () => {
    setShowSnaptradeModal((prevState) => !prevState);
  };

  const BackIcon = () => {
    return (
      <Button
        size="small"
        className="move-back-btn"
        onClick={handleNavigateToParent}
      >
        <ArrowLeftIcon fill="#fff" />
      </Button>
    );
  };

  return (
    <AppMenuContainer>
      <LocationPath changedPath={handleChangePath} />
      <ul>
        <li className={"menu-item active close-menu"} onClick={toggleCollapsed}>
          <div className="inner-item" tabIndex={0} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                {collapsed && (
                  <img
                    alt="toggle"
                    src={hamburgerIcon}
                    className="hamburger-icon"
                  />
                )}
                {!collapsed && (
                  <img
                    alt="toggle"
                    src={closeIcon}
                    className="hamburger-icon"
                  />
                )}
              </span>
            </span>
            <span className="item-content">Close</span>
          </div>
        </li>

        {showBackButton && (
          <li className="menu-item active">
            <div className="inner-item" tabIndex={1} role="button">
              {collapsed && (
                <span className="icon-wrapper">
                  <span className="icon">
                    <BackIcon fill={theme.aside.icon.primary} />
                  </span>
                </span>
              )}
              {!collapsed && (
                <span className="item-content mx-0">
                  <Button
                    size="small"
                    className="move-back-btn"
                    width="100%"
                    onClick={handleNavigateToParent}
                  >
                    <ArrowLeftIcon fill="#fff" /> Back
                  </Button>
                </span>
              )}
            </div>
          </li>
        )}

        <li
          className={classNames("menu-item wt-nav-portfolio", {
            active: active.startsWith(DASHBOARD_PATH) || active === "/",
            // open: isDashboardOpen,
          })}
          onClick={() => navigateToV2(DASHBOARD_PATH)}
        >
          <div
            className="inner-item"
            tabIndex={2}
            role="button"
            // onClick={toggleDashboardDropdown}
          >
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <DashboardIcon
                    stroke={
                      active.startsWith(DASHBOARD_PATH) || active === "/"
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip value="Dashboard">
                    <DashboardIcon
                      stroke={
                        active.startsWith(DASHBOARD_PATH) || active === "/"
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && (
              <span className="item-content mt-1">
                Dashboard
                {/* <span
                  className={classNames("chevron", { open: isDashboardOpen })}
                >
                  <ChevronDownIcon />
                </span> */}
              </span>
            )}
          </div>
          {/* {!collapsed && isDashboardOpen && (
            <ul className="submenu">
              <li className="submenu-title">All portfolios</li>
              <div className="portfolio-list-container">
                {isLoading ? (
                  <li className="submenu-loading">Loading...</li>
                ) : portfolios && portfolios.length > 0 ? (
                  portfolios.map((account) => {
                    const isSelected = selectedPortfolioIds.includes(
                      String(account.id)
                    );

                    return (
                      <li
                        key={account.id}
                        className={`account-item ${
                          isSelected ? "selected" : ""
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => handleAccountSelect(account)}
                        >
                          <img
                            src={account.icon}
                            alt={account.broker}
                            className="account-icon"
                          />
                          <Tooltip value={account.nickname} placement="right">
                            <span className="account-broker">
                              {account.nickname}
                            </span>
                          </Tooltip>
                        </button>
                      </li>
                    );
                  })
                ) : (
                  <li className="submenu-empty">No accounts connected</li>
                )}
              </div>
              <li className="account-item">
                <button type="button" onClick={toggleSnaptradeModal}>
                  <PlusCircleIcon />
                  Add an account
                </button>
              </li>
            </ul>
          )} */}
        </li>

        <li
          className={classNames("menu-item wt-nav-marketplace", {
            active: active.startsWith(MARKETPLACE_V2_PATH),
          })}
          onClick={handlenavigateToV2Marketplace}
        >
          <div className="inner-item" tabIndex={3} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                <div className="marketplace-icon">
                  {!collapsed ? (
                    <MarketplaceIcon
                      stroke={
                        active.startsWith(MARKETPLACE_V2_PATH)
                          ? theme.aside.icon.primary
                          : "#A4A7AE"
                      }
                    />
                  ) : (
                    <Tooltip value="Market">
                      <MarketplaceIcon
                        stroke={
                          active.startsWith(MARKETPLACE_V2_PATH)
                            ? theme.aside.icon.primary
                            : "#A4A7AE"
                        }
                      />
                    </Tooltip>
                  )}
                </div>
              </span>
            </span>
            {!collapsed && <span className="item-content mt-1">Market</span>}
          </div>
        </li>

        <li
          className={classNames("menu-item wt-nav-own-strategy", {
            active: active.startsWith(STRATEGY_V2_PATH),
            "sidebar-menu-disabled": hasFreeOrCore(),
          })}
          onClick={!hasFreeOrCore() ? handleNavigateToStrategyList : undefined}
        >
          <div
            className="inner-item"
            tabIndex={4}
            role="button"
            onClick={hasFreeOrCore() ? togglePurchasePlanModal : undefined}
          >
            <span className="icon-wrapper create-spacing">
              <span className="icon">
                {!collapsed ? (
                  <CreateStrategiesIcon
                    className="create-strategy"
                    stroke={
                      active.startsWith(STRATEGY_V2_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip value="Create Strategy">
                    <CreateStrategiesIcon
                      fill={
                        active.startsWith(STRATEGY_V2_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && (
              <span className="item-content ">
                Create
                {hasFreeOrCore() && (
                  <IconLock
                    className="sidebar-lock-icon"
                    title="Upgrade to premium to access Create"
                  />
                )}
              </span>
            )}
          </div>
        </li>

        <li
          className={classNames("menu-item", {
            active: active.startsWith(MARKET_V2_PATH),
          })}
          onClick={handleNavigateToStockSearch}
        >
          {/* <div className="inner-item" tabIndex={5} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <SearchIcon2
                    fill={
                      active.startsWith(MARKET_V2_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip tooltipValue="Legacy Markets">
                    <SearchIcon2
                      fill={
                        active.startsWith(MARKET_V2_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && <span className="item-content">Legacy Markets</span>}
          </div> */}
        </li>

        <li
          className={classNames("menu-item", {
            active: active.startsWith(RESEARCH_PATH),
          })}
          onClick={handleNavigateToResearch}
        >
          <div className="inner-item" tabIndex={6} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <SidebarResearchIcon
                    stroke={
                      active.startsWith(RESEARCH_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip tooltipValue="Research">
                    <SidebarResearchIcon
                      stroke={
                        active.startsWith(RESEARCH_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && <span className="item-content">Research</span>}
          </div>
        </li>

        {/* Choose Plan Modal for locked sidebar items */}
        <ChoosePlanModal
          show={showPurchasePlanModal}
          onHide={togglePurchasePlanModal}
        />
      </ul>

      {/* Snaptrade Modal */}
      {showSnaptradeModal && (
        <MultiStepModal
          show={showSnaptradeModal}
          onHide={toggleSnaptradeModal}
          onSuccess={() => {
            refetch();
            toggleSnaptradeModal();
          }}
        />
      )}
    </AppMenuContainer>
  );
};

AppMenu.propTypes = {
  active: PropTypes.string,
};
